export const PADRAO_FILTRO_CAMPO = 'PADRAO_FILTRO_CAMPO';